var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ThemedImage/index.tsx";
import React from 'react';
import { HStack } from '@adc/parallax-component-library';
import { useThemedResource } from 'Hooks';
function ThemedImage({
  resourceKey,
  testID,
  alt,
  style
}) {
  const resource = useThemedResource(resourceKey);
  return /*#__PURE__*/React.createElement(HStack, {
    testID: testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: resource.src,
    alt: alt,
    id: testID ?? resource.key,
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }));
}
export { ThemedImage };